/**
 * Example config:
 * {
 *   eventId: 'e9b5be85-1f71-409b-8b4b-67d3700853f6',
 *   details: ['name', 'registration:Organisation', 'registration:Industry'],
 *   debug: false,
 * }
 *
 * Available details:
 * - name
 * - email
 * - ticketTitle
 * - registration:<field name> (for example registration:Job Title)
 *
 * Detail order controls badge lines: large, medium, small. Maximum 3.
 * Set debug to true to log badge content without printing or marking it printed.
 */

export type BadgeDetail =
  'name' | 'email' | 'ticketTitle' | `registration:${string}`

export type BadgePrintingConfig = {
  eventId: string
  details: readonly [BadgeDetail, BadgeDetail?, BadgeDetail?]
  debug?: boolean
}

export const BADGE_PRINTING_CONFIGS: BadgePrintingConfig[] = [
  {
    eventId: 'e9b5be85-1f71-409b-8b4b-67d3700853f6',
    details: ['name', 'registration:Company', 'registration:Industry'],
    debug: false,
  },

  {
    eventId: '7f75a75d-ab8a-4b14-8acd-1b789f5bcdfa',
    details: ['name'],
    debug: false,
  },
]

export const getBadgePrintingConfig = (eventId: string) =>
  BADGE_PRINTING_CONFIGS.find((config) => config.eventId === eventId)
